import React from "react"
import { Drawer as DrawerPrimitive } from "@base-ui/react/drawer"
import { cn } from "../utils"

export type DrawerTitleProps = {
  children?: React.ReactNode
  className?: string
}

const titleStyles = "text-2xl font-semibold leading-10 text-gray-800"

/**
 * The drawer's heading.
 *
 * Required to supply the accessible name for the drawer panel.
 */
export function DrawerTitle({ children, className }: DrawerTitleProps) {
  return (
    <DrawerPrimitive.Title
      data-slot="drawer-title"
      className={cn(titleStyles, className)}
    >
      {children}
    </DrawerPrimitive.Title>
  )
}

DrawerTitle.displayName = "Drawer.Title"
